import React from 'react'
import PropTypes from 'prop-types'

const HistoryLinkButton = ({
  onClick,
  children,
  className = 'activeCollection_historyLink readMoreLink',
  href,
  ...props
}) => {
  // If href is provided, render as anchor, otherwise as button
  if (href) {
    return (
      <a
        className={className}
        href={href}
        onClick={onClick}
        {...props}
      >
        {children}
      </a>
    )
  }

  return (
    <button
      className={className}
      onClick={onClick}
      type="button"
      {...props}
    >
      {children}
    </button>
  )
}

HistoryLinkButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func.isRequired,
}

export default HistoryLinkButton
